"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var palette_1 = require("../constants/palette");

var Label = styled_components_1.default.label(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 8px;\n  font-size: 13px;\n  ", "\n"], ["\n  color: ", ";\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 8px;\n  font-size: 13px;\n  ", "\n"])), palette_1.default.darkGrey, function (props) {
  return props.required && "\n    &::after {\n      position: relative;\n      left: 2px;\n      content: '*';\n      color: " + palette_1.default.red + ";\n    }\n  ";
});
exports.default = Label;
var templateObject_1;